// extracted by mini-css-extract-plugin
export var consultant = "styles-module--consultant--109ad";
export var initial = "styles-module--initial--a1e47";
export var optional = "styles-module--optional--bd78c";
export var text = "styles-module--text--7453f";
export var voice = "styles-module--voice--480b3";